export function isNullOrEmpty(str: string | undefined | null)
{
	return (!str || 0 === str.length);
}